import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  CircularProgress
} from '@mui/material';
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import BannerUploadModal from './BannerUploadModal';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const getImageUrl = (image) => {
  if (!image) return null;
  if (/^https?:\/\//i.test(image)) return image;
  return `${API_URL.replace('/api', '')}${image.startsWith('/') ? image : `/${image}`}`;
};

const BannersSection = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('@DeliveryAdmin:token');
      const response = await fetch(`${API_URL}/banners/all`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      setBanners(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Erro ao buscar banners:', error);
      alert('Erro', 'Falha ao carregar banners');
      setBanners([]);
    } finally {
      setLoading(false);
    }
  };

  
  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este banner?')) {
      try {
        const token = localStorage.getItem('@DeliveryAdmin:token');
        const response = await fetch(`${API_URL}/banners/${id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          alert('Banner excluido com sucesso!');
          fetchBanners();
        } else {
          alert('Falha ao excluir banner');
        }
      } catch (error) {
        alert('Falha ao excluir banner');
      }
    }
  };

  const handleEdit = (banner) => {
    setUploadModalOpen(true);
  };

  
  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h2">
          📋 Gerenciamento de Banners
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => setUploadModalOpen(true)}
        >
          Novo Banner
        </Button>
      </Box>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={3}>
          {banners.map((banner) => (
            <Grid item xs={12} md={6} lg={4} key={banner.id}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                    <Box>
                      <Typography variant="h6" component="h3">
                        {banner.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {banner.active ? '✅ Ativo' : '❌ Inativo'}
                      </Typography>
                    </Box>
                    
                    <Box>
                      <IconButton
                        color="primary"
                        onClick={() => handleEdit(banner)}
                        sx={{ mr: 1 }}
                      >
                        <EditIcon />
                      </IconButton>
                      
                      <IconButton
                        color="error"
                        onClick={() => handleDelete(banner.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  </Box>

                  {banner.image && (
                    <Box sx={{ mt: 2 }}>
                      <img 
                        src={getImageUrl(banner.image)}
                        alt={banner.title}
                        style={{ 
                          width: '100%', 
                          maxHeight: 200, 
                          borderRadius: 2,
                          objectFit: 'cover'
                        }}
                      />
                    </Box>
                  )}

                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Link: {banner.link || 'Nenhum'}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Modal de Upload de Banner */}
      <BannerUploadModal
        open={uploadModalOpen}
        onClose={() => setUploadModalOpen(false)}
        onUpload={(bannerData) => {
          console.log('Banner criado:', bannerData);
          setUploadModalOpen(false);
          fetchBanners();
        }}
        title="Novo Banner"
      />
    </Box>
  );
};

export default BannersSection;
